import { BankAccount, Transaction } from '../types/banking'

// Bank accounts for each company
export const bankAccounts: BankAccount[] = [
  // Workflow Finance accounts
  {
    id: 'acc-wf-checking',
    company_id: 'wf',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    name: 'Business Checking',
    official_name: 'Workflow Finance Business Checking Account',
    type: 'checking',
    subtype: 'checking',
    mask: '4242',
    current_balance: 45280.5,
    available_balance: 45280.5,
    currency: 'USD',
    institution_name: 'Chase Bank',
    institution_id: 'ins_3',
  },
  {
    id: 'acc-wf-credit',
    company_id: 'wf',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    name: 'Business Credit Card',
    official_name: 'Chase Ink Business Preferred Credit Card',
    type: 'credit_card',
    subtype: 'credit card',
    mask: '8888',
    current_balance: -3240.75,
    available_balance: 21759.25,
    currency: 'USD',
    institution_name: 'Chase Bank',
    institution_id: 'ins_3',
  },
  // Acme Corp accounts
  {
    id: 'acc-acme-checking',
    company_id: 'acme',
    account_id: 'zMzMxNk2o6JZPEq1YbbYiAXdRlZ38GJyx11xr',
    name: 'Business Checking',
    official_name: 'Acme Corp Business Checking Account',
    type: 'checking',
    subtype: 'checking',
    mask: '1234',
    current_balance: 128450.25,
    available_balance: 128450.25,
    currency: 'USD',
    institution_name: 'Bank of America',
    institution_id: 'ins_4',
  },
  {
    id: 'acc-acme-credit',
    company_id: 'acme',
    account_id: 'pLpLxOl3p7KaPFr2ZccZjBYeSmZ49HKzy22ys',
    name: 'Business Credit Card',
    official_name: 'Bank of America Business Advantage Cash Rewards',
    type: 'credit_card',
    subtype: 'credit card',
    mask: '5678',
    current_balance: -5680.4,
    available_balance: 19319.6,
    currency: 'USD',
    institution_name: 'Bank of America',
    institution_id: 'ins_4',
  },
]

// Helper to generate dates
const getDate = (daysAgo: number) => {
  const date = new Date()
  date.setDate(date.getDate() - daysAgo)
  return date
}

// Generate 100 realistic transactions
export const transactions: Transaction[] = [
  // --- JANUARY 2024 ---
  {
    id: 'txn-100',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_100',
    amount: -5000.0,
    iso_currency_code: 'USD',
    date: getDate(2),
    authorized_date: getDate(2),
    datetime: getDate(2),
    name: 'DEPOSIT - CLIENT PAYMENT',
    merchant_name: null,
    category: ['Transfer', 'Deposit'],
    category_id: '21001000',
    personal_finance_category: {
      primary: 'INCOME',
      detailed: 'INCOME_OTHER_INCOME',
    },
    payment_channel: 'other',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: null,
      region: null,
      postal_code: null,
      country: null,
    },
  },
  {
    id: 'txn-99',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_99',
    amount: 120.0,
    iso_currency_code: 'USD',
    date: getDate(3),
    authorized_date: getDate(3),
    datetime: getDate(3),
    name: 'PG&E UTILITIES',
    merchant_name: 'PG&E',
    category: ['Service', 'Utilities'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_UTILITIES',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-98',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_98',
    amount: 45.5,
    iso_currency_code: 'USD',
    date: getDate(4),
    authorized_date: getDate(4),
    datetime: getDate(4),
    name: 'SHELL OIL',
    merchant_name: 'Shell',
    category: ['Travel', 'Gas Stations'],
    category_id: '22009000',
    personal_finance_category: {
      primary: 'TRANSPORTATION',
      detailed: 'TRANSPORTATION_GAS_STATIONS',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: '123 Main St',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94105',
      country: 'US',
    },
  },
  {
    id: 'txn-97',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_97',
    amount: 2500.0,
    iso_currency_code: 'USD',
    date: getDate(5),
    authorized_date: getDate(5),
    datetime: getDate(5),
    name: 'OFFICE RENT',
    merchant_name: 'WeWork',
    category: ['Service', 'Rent'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_RENT',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-96',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_96',
    amount: 12.5,
    iso_currency_code: 'USD',
    date: getDate(6),
    authorized_date: getDate(6),
    datetime: getDate(6),
    name: 'STARBUCKS',
    merchant_name: 'Starbucks',
    category: ['Food and Drink', 'Coffee Shop'],
    category_id: '13005043',
    personal_finance_category: {
      primary: 'FOOD_AND_DRINK',
      detailed: 'FOOD_AND_DRINK_COFFEE',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: '456 Market St',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94103',
      country: 'US',
    },
  },
  {
    id: 'txn-95',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_95',
    amount: 89.99,
    iso_currency_code: 'USD',
    date: getDate(7),
    authorized_date: getDate(7),
    datetime: getDate(7),
    name: 'INTERNET SERVICE',
    merchant_name: 'Comcast',
    category: ['Service', 'Utilities'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_INTERNET',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-94',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_94',
    amount: 150.0,
    iso_currency_code: 'USD',
    date: getDate(8),
    authorized_date: getDate(8),
    datetime: getDate(8),
    name: 'CLIENT DINNER',
    merchant_name: 'The House',
    category: ['Food and Drink', 'Restaurants'],
    category_id: '13005000',
    personal_finance_category: {
      primary: 'FOOD_AND_DRINK',
      detailed: 'FOOD_AND_DRINK_RESTAURANT',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: '1230 Grant Ave',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94133',
      country: 'US',
    },
  },
  {
    id: 'txn-93',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_93',
    amount: -1200.0,
    iso_currency_code: 'USD',
    date: getDate(9),
    authorized_date: getDate(9),
    datetime: getDate(9),
    name: 'DEPOSIT - REFUND',
    merchant_name: null,
    category: ['Transfer', 'Deposit'],
    category_id: '21001000',
    personal_finance_category: {
      primary: 'INCOME',
      detailed: 'INCOME_REFUNDS',
    },
    payment_channel: 'other',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: null,
      region: null,
      postal_code: null,
      country: null,
    },
  },
  {
    id: 'txn-92',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_92',
    amount: 29.99,
    iso_currency_code: 'USD',
    date: getDate(10),
    authorized_date: getDate(10),
    datetime: getDate(10),
    name: 'LINKEDIN PREMIUM',
    merchant_name: 'LinkedIn',
    category: ['Service', 'Subscription'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_SUBSCRIPTIONS',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'Sunnyvale',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-91',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_91',
    amount: 350.0,
    iso_currency_code: 'USD',
    date: getDate(11),
    authorized_date: getDate(11),
    datetime: getDate(11),
    name: 'OFFICE SUPPLIES',
    merchant_name: 'Staples',
    category: ['Shops', 'Office Supplies'],
    category_id: '19047000',
    personal_finance_category: {
      primary: 'GENERAL_MERCHANDISE',
      detailed: 'GENERAL_MERCHANDISE_OFFICE_SUPPLIES',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'Framingham',
      region: 'MA',
      postal_code: null,
      country: 'US',
    },
  },

  // --- DECEMBER 2023 ---
  {
    id: 'txn-90',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_90',
    amount: -8500.0,
    iso_currency_code: 'USD',
    date: getDate(35),
    authorized_date: getDate(35),
    datetime: getDate(35),
    name: 'DEPOSIT - PROJECT COMPLETION',
    merchant_name: null,
    category: ['Transfer', 'Deposit'],
    category_id: '21001000',
    personal_finance_category: {
      primary: 'INCOME',
      detailed: 'INCOME_OTHER_INCOME',
    },
    payment_channel: 'other',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: null,
      region: null,
      postal_code: null,
      country: null,
    },
  },
  {
    id: 'txn-89',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_89',
    amount: 1200.0,
    iso_currency_code: 'USD',
    date: getDate(36),
    authorized_date: getDate(36),
    datetime: getDate(36),
    name: 'APPLE STORE',
    merchant_name: 'Apple',
    category: ['Shops', 'Electronics'],
    category_id: '19013002',
    personal_finance_category: {
      primary: 'GENERAL_MERCHANDISE',
      detailed: 'GENERAL_MERCHANDISE_ELECTRONICS',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: '1 Stockton St',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94108',
      country: 'US',
    },
  },
  {
    id: 'txn-88',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_88',
    amount: 450.0,
    iso_currency_code: 'USD',
    date: getDate(38),
    authorized_date: getDate(38),
    datetime: getDate(38),
    name: 'AWS',
    merchant_name: 'Amazon Web Services',
    category: ['Service', 'Cloud Computing'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_OTHER_GENERAL_SERVICES',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'Seattle',
      region: 'WA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-87',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_87',
    amount: 65.0,
    iso_currency_code: 'USD',
    date: getDate(40),
    authorized_date: getDate(40),
    datetime: getDate(40),
    name: 'UBER RIDE',
    merchant_name: 'Uber',
    category: ['Travel', 'Taxi'],
    category_id: '22016000',
    personal_finance_category: {
      primary: 'TRANSPORTATION',
      detailed: 'TRANSPORTATION_TAXIS_AND_RIDE_SHARES',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-86',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_86',
    amount: 2500.0,
    iso_currency_code: 'USD',
    date: getDate(42),
    authorized_date: getDate(42),
    datetime: getDate(42),
    name: 'OFFICE RENT',
    merchant_name: 'WeWork',
    category: ['Service', 'Rent'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_RENT',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-85',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_85',
    amount: 145.0,
    iso_currency_code: 'USD',
    date: getDate(45),
    authorized_date: getDate(45),
    datetime: getDate(45),
    name: 'TEAM LUNCH',
    merchant_name: 'Chipotle',
    category: ['Food and Drink', 'Restaurants'],
    category_id: '13005000',
    personal_finance_category: {
      primary: 'FOOD_AND_DRINK',
      detailed: 'FOOD_AND_DRINK_RESTAURANT',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: '525 Market St',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94105',
      country: 'US',
    },
  },
  {
    id: 'txn-84',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_84',
    amount: 89.99,
    iso_currency_code: 'USD',
    date: getDate(48),
    authorized_date: getDate(48),
    datetime: getDate(48),
    name: 'ADOBE CREATIVE CLOUD',
    merchant_name: 'Adobe',
    category: ['Service', 'Software'],
    category_id: '19013001',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_SOFTWARE',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Jose',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-83',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_83',
    amount: 230.0,
    iso_currency_code: 'USD',
    date: getDate(50),
    authorized_date: getDate(50),
    datetime: getDate(50),
    name: 'SOUTHWEST AIRLINES',
    merchant_name: 'Southwest',
    category: ['Travel', 'Airlines'],
    category_id: '22001000',
    personal_finance_category: {
      primary: 'TRAVEL',
      detailed: 'TRAVEL_FLIGHTS',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'Dallas',
      region: 'TX',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-82',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_82',
    amount: 1500.0,
    iso_currency_code: 'USD',
    date: getDate(55),
    authorized_date: getDate(55),
    datetime: getDate(55),
    name: 'PAYROLL',
    merchant_name: 'Gusto',
    category: ['Service', 'Payroll'],
    category_id: '10000000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_ACCOUNTING_AND_FINANCIAL_PLANNING',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-81',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_81',
    amount: 45.0,
    iso_currency_code: 'USD',
    date: getDate(58),
    authorized_date: getDate(58),
    datetime: getDate(58),
    name: 'SHELL OIL',
    merchant_name: 'Shell',
    category: ['Travel', 'Gas Stations'],
    category_id: '22009000',
    personal_finance_category: {
      primary: 'TRANSPORTATION',
      detailed: 'TRANSPORTATION_GAS_STATIONS',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: '123 Main St',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94105',
      country: 'US',
    },
  },

  // --- NOVEMBER 2023 ---
  {
    id: 'txn-80',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_80',
    amount: -4200.0,
    iso_currency_code: 'USD',
    date: getDate(65),
    authorized_date: getDate(65),
    datetime: getDate(65),
    name: 'DEPOSIT - RETAINER',
    merchant_name: null,
    category: ['Transfer', 'Deposit'],
    category_id: '21001000',
    personal_finance_category: {
      primary: 'INCOME',
      detailed: 'INCOME_OTHER_INCOME',
    },
    payment_channel: 'other',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: null,
      region: null,
      postal_code: null,
      country: null,
    },
  },
  {
    id: 'txn-79',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_79',
    amount: 890.0,
    iso_currency_code: 'USD',
    date: getDate(68),
    authorized_date: getDate(68),
    datetime: getDate(68),
    name: 'DELL COMPUTERS',
    merchant_name: 'Dell',
    category: ['Shops', 'Electronics'],
    category_id: '19013002',
    personal_finance_category: {
      primary: 'GENERAL_MERCHANDISE',
      detailed: 'GENERAL_MERCHANDISE_ELECTRONICS',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'Round Rock',
      region: 'TX',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-78',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_78',
    amount: 450.0,
    iso_currency_code: 'USD',
    date: getDate(70),
    authorized_date: getDate(70),
    datetime: getDate(70),
    name: 'AWS',
    merchant_name: 'Amazon Web Services',
    category: ['Service', 'Cloud Computing'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_OTHER_GENERAL_SERVICES',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'Seattle',
      region: 'WA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-77',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_77',
    amount: 120.0,
    iso_currency_code: 'USD',
    date: getDate(72),
    authorized_date: getDate(72),
    datetime: getDate(72),
    name: 'CLIENT GIFT',
    merchant_name: 'Harry & David',
    category: ['Shops', 'Gifts'],
    category_id: '19026000',
    personal_finance_category: {
      primary: 'GENERAL_MERCHANDISE',
      detailed: 'GENERAL_MERCHANDISE_GIFTS',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'Medford',
      region: 'OR',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-76',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_76',
    amount: 2500.0,
    iso_currency_code: 'USD',
    date: getDate(75),
    authorized_date: getDate(75),
    datetime: getDate(75),
    name: 'OFFICE RENT',
    merchant_name: 'WeWork',
    category: ['Service', 'Rent'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_RENT',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-75',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_75',
    amount: 45.0,
    iso_currency_code: 'USD',
    date: getDate(78),
    authorized_date: getDate(78),
    datetime: getDate(78),
    name: 'UBER EATS',
    merchant_name: 'Uber Eats',
    category: ['Food and Drink', 'Delivery'],
    category_id: '13005000',
    personal_finance_category: {
      primary: 'FOOD_AND_DRINK',
      detailed: 'FOOD_AND_DRINK_RESTAURANT',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-74',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_74',
    amount: 1500.0,
    iso_currency_code: 'USD',
    date: getDate(80),
    authorized_date: getDate(80),
    datetime: getDate(80),
    name: 'PAYROLL',
    merchant_name: 'Gusto',
    category: ['Service', 'Payroll'],
    category_id: '10000000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_ACCOUNTING_AND_FINANCIAL_PLANNING',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-73',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_73',
    amount: 320.0,
    iso_currency_code: 'USD',
    date: getDate(82),
    authorized_date: getDate(82),
    datetime: getDate(82),
    name: 'HILTON HOTEL',
    merchant_name: 'Hilton',
    category: ['Travel', 'Lodging'],
    category_id: '22013000',
    personal_finance_category: {
      primary: 'TRAVEL',
      detailed: 'TRAVEL_LODGING',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: "333 O'Farrell St",
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94102',
      country: 'US',
    },
  },
  {
    id: 'txn-72',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_72',
    amount: 89.99,
    iso_currency_code: 'USD',
    date: getDate(85),
    authorized_date: getDate(85),
    datetime: getDate(85),
    name: 'INTERNET SERVICE',
    merchant_name: 'Comcast',
    category: ['Service', 'Utilities'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_INTERNET',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-71',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_71',
    amount: 25.0,
    iso_currency_code: 'USD',
    date: getDate(88),
    authorized_date: getDate(88),
    datetime: getDate(88),
    name: 'PARKING',
    merchant_name: 'SFMTA',
    category: ['Travel', 'Parking'],
    category_id: '22014000',
    personal_finance_category: {
      primary: 'TRANSPORTATION',
      detailed: 'TRANSPORTATION_PARKING',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },

  // --- OCTOBER 2023 ---
  {
    id: 'txn-70',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_70',
    amount: -6000.0,
    iso_currency_code: 'USD',
    date: getDate(95),
    authorized_date: getDate(95),
    datetime: getDate(95),
    name: 'DEPOSIT - CONSULTING',
    merchant_name: null,
    category: ['Transfer', 'Deposit'],
    category_id: '21001000',
    personal_finance_category: {
      primary: 'INCOME',
      detailed: 'INCOME_OTHER_INCOME',
    },
    payment_channel: 'other',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: null,
      region: null,
      postal_code: null,
      country: null,
    },
  },
  {
    id: 'txn-69',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_69',
    amount: 1500.0,
    iso_currency_code: 'USD',
    date: getDate(98),
    authorized_date: getDate(98),
    datetime: getDate(98),
    name: 'CONFERENCE TICKETS',
    merchant_name: 'TechCrunch',
    category: ['Service', 'Conference'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_OTHER_GENERAL_SERVICES',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-68',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_68',
    amount: 450.0,
    iso_currency_code: 'USD',
    date: getDate(100),
    authorized_date: getDate(100),
    datetime: getDate(100),
    name: 'AWS',
    merchant_name: 'Amazon Web Services',
    category: ['Service', 'Cloud Computing'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_OTHER_GENERAL_SERVICES',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'Seattle',
      region: 'WA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-67',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_67',
    amount: 85.0,
    iso_currency_code: 'USD',
    date: getDate(102),
    authorized_date: getDate(102),
    datetime: getDate(102),
    name: 'TEAM DINNER',
    merchant_name: 'Liholiho',
    category: ['Food and Drink', 'Restaurants'],
    category_id: '13005000',
    personal_finance_category: {
      primary: 'FOOD_AND_DRINK',
      detailed: 'FOOD_AND_DRINK_RESTAURANT',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: '871 Sutter St',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94109',
      country: 'US',
    },
  },
  {
    id: 'txn-66',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_66',
    amount: 2500.0,
    iso_currency_code: 'USD',
    date: getDate(105),
    authorized_date: getDate(105),
    datetime: getDate(105),
    name: 'OFFICE RENT',
    merchant_name: 'WeWork',
    category: ['Service', 'Rent'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_RENT',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-65',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_65',
    amount: 45.0,
    iso_currency_code: 'USD',
    date: getDate(108),
    authorized_date: getDate(108),
    datetime: getDate(108),
    name: 'SHELL OIL',
    merchant_name: 'Shell',
    category: ['Travel', 'Gas Stations'],
    category_id: '22009000',
    personal_finance_category: {
      primary: 'TRANSPORTATION',
      detailed: 'TRANSPORTATION_GAS_STATIONS',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: '123 Main St',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94105',
      country: 'US',
    },
  },
  {
    id: 'txn-64',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_64',
    amount: 1500.0,
    iso_currency_code: 'USD',
    date: getDate(110),
    authorized_date: getDate(110),
    datetime: getDate(110),
    name: 'PAYROLL',
    merchant_name: 'Gusto',
    category: ['Service', 'Payroll'],
    category_id: '10000000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_ACCOUNTING_AND_FINANCIAL_PLANNING',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Francisco',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-63',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_63',
    amount: 18.5,
    iso_currency_code: 'USD',
    date: getDate(112),
    authorized_date: getDate(112),
    datetime: getDate(112),
    name: 'FEDEX SHIPPING',
    merchant_name: 'FedEx',
    category: ['Service', 'Shipping'],
    category_id: '19013000',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_POSTAGE_AND_SHIPPING',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: '100 Market St',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94105',
      country: 'US',
    },
  },
  {
    id: 'txn-62',
    account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    transaction_id: 'txn_62',
    amount: 89.99,
    iso_currency_code: 'USD',
    date: getDate(115),
    authorized_date: getDate(115),
    datetime: getDate(115),
    name: 'ADOBE CREATIVE CLOUD',
    merchant_name: 'Adobe',
    category: ['Service', 'Software'],
    category_id: '19013001',
    personal_finance_category: {
      primary: 'GENERAL_SERVICES',
      detailed: 'GENERAL_SERVICES_SOFTWARE',
    },
    payment_channel: 'online',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'special',
    check_number: null,
    location: {
      address: null,
      city: 'San Jose',
      region: 'CA',
      postal_code: null,
      country: 'US',
    },
  },
  {
    id: 'txn-61',
    account_id: 'qKKqQm8jn5IYNDo0XaaXhZWcQkY27FIxw00wq',
    transaction_id: 'txn_61',
    amount: 12.5,
    iso_currency_code: 'USD',
    date: getDate(118),
    authorized_date: getDate(118),
    datetime: getDate(118),
    name: 'STARBUCKS',
    merchant_name: 'Starbucks',
    category: ['Food and Drink', 'Coffee Shop'],
    category_id: '13005043',
    personal_finance_category: {
      primary: 'FOOD_AND_DRINK',
      detailed: 'FOOD_AND_DRINK_COFFEE',
    },
    payment_channel: 'in_store',
    pending: false,
    pending_transaction_id: null,
    transaction_type: 'place',
    check_number: null,
    location: {
      address: '456 Market St',
      city: 'San Francisco',
      region: 'CA',
      postal_code: '94103',
      country: 'US',
    },
  },
]
